module.exports = __webpack_public_path__ + "img/app-img.3a10ac2.webp";